import { Environment } from '@abp/ng.core';

const baseUrl = 'https://mallflow.yemenhybrid.com';

const oAuthConfig = {
  issuer: 'https://api.mallflow.yemenhybrid.com/',
  redirectUri: baseUrl,
  clientId: 'MallManagement_App',
  responseType: 'code',
  scope: 'offline_access MallManagement',
  requireHttps: true,
};

export const environment = {
  production: true,
  application: {
    baseUrl,
    name: 'MallManagement',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://api.mallflow.yemenhybrid.com',
      rootNamespace: 'MallManagement',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  remoteEnv: {
    url: '/getEnvConfig',
    mergeStrategy: 'deepmerge'
  }
} as Environment;
